import { render, staticRenderFns } from "./MoveFolderDialog.vue?vue&type=template&id=47b0a6e1&scoped=true"
import script from "./MoveFolderDialog.vue?vue&type=script&lang=js"
export * from "./MoveFolderDialog.vue?vue&type=script&lang=js"
import style0 from "./MoveFolderDialog.vue?vue&type=style&index=0&id=47b0a6e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b0a6e1",
  null
  
)

export default component.exports